import { createStore } from './createStore';

const initialState = {
  voices: [],
};

const normalizeVoice = (voice, { defaultStatus = null } = {}) => {
  if (!voice || typeof voice !== 'object') return null;
  const id = voice.id || null;
  if (!id) return null;

  return {
    ...voice,
    id,
    projectId: voice.projectId ?? voice.project_id ?? null,
    generationId: voice.generationId ?? voice.generation_id ?? null,
    klingVoiceId: voice.klingVoiceId ?? voice.kling_voice_id ?? null,
    previewUrl: voice.previewUrl ?? voice.preview_url ?? null,
    createdAt: voice.createdAt ?? voice.created_at ?? null,
    updatedAt: voice.updatedAt ?? voice.updated_at ?? null,
    status: voice.status ?? defaultStatus,
  };
};

/**
 * Voice store for custom voices created using ElevenLabs.
 */
export const useVoicesStore = createStore('VoicesStore', (set) => ({
  ...initialState,

  setVoices: (voices) =>
    set({
      voices: Array.isArray(voices)
        ? voices.map((voice) => normalizeVoice(voice, { defaultStatus: 'pending' })).filter(Boolean)
        : [],
    }),

  addVoice: (voice) =>
    set((state) => {
      const normalized = normalizeVoice(voice);
      if (!normalized?.id) return state;
      const existingIndex = state.voices.findIndex((existing) => existing.id === normalized.id);
      if (existingIndex !== -1) {
        const existing = state.voices[existingIndex];
        const merged = {
          ...existing,
          ...normalized,
          status: normalized.status ?? existing.status,
        };
        return {
          voices: state.voices.map((item, index) => (index === existingIndex ? merged : item)),
        };
      }
      return {
        voices: [{ ...normalized, status: normalized.status ?? 'pending' }, ...state.voices],
      };
    }),

  updateVoice: (voiceId, updates) =>
    set((state) => ({
      voices: state.voices.map((voice) =>
        voice.id === voiceId ? { ...voice, ...(normalizeVoice({ ...voice, ...updates }) || {}) } : voice
      ),
    })),

  deleteVoice: (voiceId) =>
    set((state) => ({
      voices: state.voices.filter((voice) => voice.id !== voiceId),
    })),

  resetVoices: () => set(() => initialState),
}));





